import { render, staticRenderFns } from "./lesson-exercises.vue?vue&type=template&id=a5636dd4&scoped=true"
import script from "./lesson-exercises.vue?vue&type=script&lang=js"
export * from "./lesson-exercises.vue?vue&type=script&lang=js"
import style0 from "./lesson-exercises.vue?vue&type=style&index=0&id=a5636dd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5636dd4",
  null
  
)

export default component.exports